import React from 'react'
import loading from 'react-useanimations/lib/loading'
import UseAnimations from "react-useanimations";

export const Loading = () => {
    return (<UseAnimations animation={loading}/>)
}

export default Loading